module.exports = __webpack_public_path__ + "static/media/warning.3d2f2160.svg";